import { AHIcon, AHText, Box, useLayoutContext, useTheme } from "arkh";
import { Pressable, View } from "react-native";
import React, { useMemo } from "react";

import { DateTime } from "luxon";
import { useFragment, graphql } from "react-relay";

import { OccasionSelector_routineOccasion$key } from "./__generated__/OccasionSelector_routineOccasion.graphql";

export function OccasionSelector(props: {
  onPress(): void;
  occasion: OccasionSelector_routineOccasion$key;
  historyEnabled: boolean;
}) {
  const { startAt } = useFragment(
    graphql`
      fragment OccasionSelector_routineOccasion on RoutineOccasion {
        startAt
      }
    `,
    props.occasion
  );
  const startDateString = useMemo(
    () =>
      startAt
        ? DateTime.fromISO(startAt).toLocaleString({
            ...DateTime.DATE_MED_WITH_WEEKDAY,
            year: undefined,
          })
        : "",
    [startAt]
  );

  const theme = useTheme();
  const layout = useLayoutContext();

  return (
    <View>
      <Pressable
        onPress={() => {
          props.onPress();
        }}
        disabled={!props.historyEnabled}
        style={(state) => ({
          backgroundColor: theme["surface-primary"],
          opacity: state.pressed ? 0.5 : 1,

          flex: 1,
          alignItems: "center",
          flexDirection: "row",
          justifyContent: "center",

          borderColor: theme["border-primary"],
        })}
      >
        <Box
          style={{
            alignItems: "center",
            flexDirection: "row",
            justifyContent: "center",
          }}
        >
          <AHText
            color={props.historyEnabled ? "text-cta" : "text-primary"}
            type="subtitle"
            style={{ justifyContent: "center" }}
          >
            {startDateString}
          </AHText>
          {props.historyEnabled ? (
            <Box
              style={{
                position: "absolute",
                right: -layout.icon.small - layout.space.xxsmall,
                width: layout.icon.small + layout.space.xxsmall,
                paddingLeft: layout.space.xxsmall,
              }}
            >
              <AHIcon type="chevron-down" size="small" color="primary" />
            </Box>
          ) : null}
        </Box>
      </Pressable>
    </View>
  );
}
